import { type MouseEvent as ReactMouseEvent, useState } from 'react'
import { KibButtonNew } from '@chewy/kib-controls-react'
import ExpandLess from '@mui/icons-material/ExpandLess'
import ExpandMore from '@mui/icons-material/ExpandMore'
import { Menu, MenuItem } from '@mui/material'

import '@chewy/kib-controls-styles/dist/styles/kib-button-new.css'
import styles from './kibButtonWithMenu.module.scss'

export interface KibButtonWithMenuProps {
  buttonText: string
  className?: string
  disabled?: boolean
  loading?: boolean
  name: string
  onSelectOption: (action: string) => void
  optionsDisplayMap?: { [key: string]: string }
  optionsValueMap: { [key: string]: string }
}

export const KibButtonWithMenu = ({
  buttonText,
  className,
  disabled,
  loading,
  name,
  onSelectOption,
  optionsDisplayMap,
  optionsValueMap,
}: KibButtonWithMenuProps) => {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null)
  const open = Boolean(anchorEl)

  const handleClick = (event: ReactMouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget)
  }

  const handleClose = () => {
    setAnchorEl(null)
  }

  const handleSelect = (action: string) => {
    onSelectOption(action)
    handleClose()
  }

  const menuId = `${name}-button-menu`
  const buttonId = `${name}-button`

  return (
    <>
      <KibButtonNew
        aria-controls={open ? menuId : undefined}
        aria-expanded={open ? 'true' : undefined}
        aria-haspopup="true"
        className={className}
        disabled={disabled || loading}
        icon={open ? <ExpandLess /> : <ExpandMore />}
        iconPosition="end"
        id={buttonId}
        loading={loading}
        onClick={handleClick}
      >
        {buttonText}
      </KibButtonNew>
      <Menu
        MenuListProps={{
          'aria-labelledby': buttonId,
          autoFocus: false,
        }}
        anchorEl={anchorEl}
        anchorOrigin={{
          vertical: 'top',
          horizontal: 'left',
        }}
        autoFocus={false}
        classes={{ paper: styles.menu, list: styles.menuList }}
        id={menuId}
        open={open}
        transformOrigin={{
          vertical: 'bottom',
          horizontal: 'left',
        }}
        onClose={handleClose}
      >
        {Object.values(optionsValueMap).map((key) => (
          <MenuItem
            className={styles.menuItem}
            key={key}
            onClick={() => handleSelect(key)}
          >
            {optionsDisplayMap?.[key] ?? key}
          </MenuItem>
        ))}
      </Menu>
    </>
  )
}
